import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import meSagas from './me/saga';
import userSagas from './user/saga';
import emotionSagas from './emotion/saga';
import uploaderSagas from './uploader/saga';

export default function* rootSaga() {
  yield all([
    authSagas(),
    meSagas(),
    userSagas(),
    emotionSagas(),
    uploaderSagas(),
  ]);
}
